import { Injectable, OnInit, Renderer2, RendererFactory2 } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { PLATFORM_ID, Inject } from '@angular/core';
import { Subject } from 'rxjs/internal/Subject';
import { JwtService, LocalStorageService } from '../index.service';
import { NavigationEnd, Router } from '@angular/router';
import { AuthGuard } from '../guards/auth.guard';
import { Meta } from '@angular/platform-browser';
import { BehaviorSubject, Observable, distinctUntilChanged, filter, first, map } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export default class GlobalService implements OnInit {
  private previousUrl: BehaviorSubject<string | null> = new BehaviorSubject<string | null>(null);
  public previousUrl$: Observable<string | null> = this.previousUrl.asObservable();
  prevUrl?: string;
  currentUrl?: string;
  loadMoreTrigger = new Subject<string>();
  scrollTopValue = new Subject<number>();
  imgObject: any = {};
  animationTime: number = 1000;
  mobileToolbar: boolean = false;
  scrollVal: number = 0;
  removeMainMargin: boolean = false;
  footerPositionAbsoluteStatus = false
  touchScrollStatus = false;
  scaleStatus = false
  userAgent: any;
  returnUrl: string | null = null
  sideLinkChangeUrlNumber: number = 0;
  fullLoading = false
  CanSkippExited = true
  tableLodding = false
  renderer: Renderer2;
  constructor(
    @Inject(PLATFORM_ID) private platform: Object,
    public jwtService: JwtService,
    private authGuardService: AuthGuard,
    private router: Router,
    private MetaService: Meta,
    private rendererFactory: RendererFactory2,
    private localStorageService: LocalStorageService
  ) {
    this.renderer = rendererFactory.createRenderer(null, null);
    this.router.events.pipe(
      filter((event) => event instanceof NavigationEnd)
    ).subscribe((event: any) => {
      this.prevUrl = this.currentUrl;
      this.currentUrl = event.url;
      this.setPreviousUrl(this.prevUrl);
    });
  }
  ngOnInit(): void {
    this.setRemoveMainMargin(false)
  }

  setPreviousUrl(previousUrl: string | null | undefined) {
    this.previousUrl.next((previousUrl as any));
  }
  getPerviousUrlObs(path: any) {
    this.previousUrl$.pipe(
      first(),
      map(i => {
        // this.router.url.split('/').slice(0,this.router.url.split('/').length-1).join('/')
        return !i || i.includes(this.router.url) ? path : i
      }),
    ).subscribe(i => {
      path = i
    })
    this.router.navigate([path])
  }
  setFullLoading(bool: boolean) {
    this.fullLoading = bool
  }
  getFullLoading() {
    return this.fullLoading
  }
  lockScroll(bool: boolean) {
    let bodyElement = document.querySelector('body')
    if (bool) {
      this.renderer.addClass(bodyElement, 'overflow-y-hidden')
      this.renderer.addClass(bodyElement, 'body-custom')
    } else {
      this.renderer.removeClass(bodyElement, 'overflow-y-hidden')
      this.renderer.removeClass(bodyElement, 'body-custom')
    }
  }
  setRemoveMainMargin(value: boolean) {
    setTimeout(() => {
      this.removeMainMargin = value;
    }, 0);
  }
  scrollTop() {
    if (isPlatformBrowser(this.platform)) {
      window.scroll(0, 0);
    }
  }
  getYearFromDate(date:any){
    return date.includes('T') ? date.split('T')[0].split('-')[0] : date.split(' ')[0].split('-')[0]
  }
  setDeviceDetector(userAgent: any) {
    this.userAgent = userAgent
  }
  getDeviceDetector() {
    return this.userAgent
  }
  changeScaleStatus(status: boolean) {
    this.scaleStatus = status
  }
  scrollToView(element: string, behaviorSmooth: boolean = true, position: ScrollLogicalPosition = "start") {
    if (isPlatformBrowser(this.platform)) {
      let scrollSpy = <HTMLElement>document.querySelector("#" + element)

      scrollSpy.scrollIntoView({
        behavior: behaviorSmooth ? "smooth" : "auto",
        block: position,
        inline: "nearest"
      })
    }
  }
  scrollToTopOfView(element: string, value: number = 0) {
    if (isPlatformBrowser(this.platform)) {
      this.scrollFunction(element, value)
    }
  }
  scrollFunction(element: string, value: number) {
    setTimeout(() => {
      window.scrollTo({
        top: this.findPosition(document.querySelector("#" + element)) - value,
        left: 0,
        behavior: 'smooth',
      });
    }, 10);
  }
  findPosition(obj: any): number {
    let currenttop: number = 0;
    if (obj.offsetParent) {
      do {
        currenttop += obj.offsetTop;
      } while ((obj = obj.offsetParent));
    }
    return currenttop;
  }
  loadImage(imgName: any, time: number = 0) {
    setTimeout(() => {
      return this.imgObject[imgName] = true;
    }, time);
  }
  preventAccess() {
    if (!this.jwtService.checkAuth()) {
      this.jwtService.destination = this.router.url;
      this.authGuardService.preventAccess();
    }
  }
  setMobileToolbar(state: boolean) {
    this.mobileToolbar = state;
  }
  redirectTo(url: string) {
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() =>
      this.router.navigate([url]));
  }

  setTouchScrollStatus(status: boolean) {
    this.touchScrollStatus = status
  }

  createMetaTag(tagName: any, content: any) {
    this.MetaService.updateTag(
      { name: tagName, content: content }
    )
  }

  removeMetaTag(tagName: any) {
    this.MetaService.removeTag(`name=${tagName}`)
  }
  convertMonthDegitToText(month: string) {
    if (month == '01') return 'فروردین'
    if (month == '02') return 'اردیبهشت'
    if (month == '03') return 'خرداد'
    if (month == '04') return 'تیر'
    if (month == '05') return 'مرداد'
    if (month == '06') return 'شهریور'
    if (month == '07') return 'ماه'
    if (month == '08') return 'آبان'
    if (month == '09') return 'آذر'
    if (month == '10') return 'دی'
    if (month == '11') return 'بهمن'
    else return 'اسفند'
  }

  convertDegitAndSignChar(value: string) {
    let text = '';
    text = value.replaceAll(/[A-Za-z0-9۱۲۳۴۵۶۷۸۹۰!@#$%^&*()_+=\-[\]\\{}|;':",./<>?]/g, '')
    return text
  }
  convertDegitAndSignCharEn(value: string) {
    let text = '';

    text = value.replaceAll(/[0-9!@#$%^&*()_+=\-[\]\\{}|;':",./<>?]/g, '')
    text = text.replaceAll(/[\u0600-\u06FF\uFB8A\u067E\u0686\u06AF]/g, '')
    return text
  }
  resetPerviousPath() {
    this.previousUrl.next(null)
  }
  checkUserIsOrganObs() {
    return this.jwtService.getCurrentAccountDataObs().pipe(
      filter((account: any) => account && account.username),
      map(account => {
        return account.username
      }),
      map((username: any) => {
        if (username.split('-')[0] == 'nrh') {
          return false
        } else {
          return true
        }
      }),
      distinctUntilChanged(),
    )
  }
  getDecimal(min: any) {
    return (min + "").split(".")[1];
  }
  convertTime(time: any) {
    let timeStr;
    if (time <= 60) {
      timeStr = '1 دقیقه'
    } else {
      if (time > 60 && time < 3600) {
        let min = Math.round(time / 60)
        timeStr = `${min} دقیقه`
      } else {
        let hour = Math.round(time / 3600)
        let decimal = +this.getDecimal((time / 3600).toString()).slice(0, 2)
        let min;
        if (decimal < 10) {
          min = decimal
        } else if (decimal < 55 && decimal > 45) {
          min = 30
        } else if (decimal > 10 && decimal <= 25) {
          min = 10
        } else if (decimal > 25 && decimal <= 45) {
          min = 20
        } else if (decimal >= 55 && decimal < 75) {
          min = 40
        } else {
          min = 50
        }
        timeStr = `${hour} ساعت ${min} دقیقه`
      }
    }
    return timeStr
  }
  isAfarine() {
    if (environment.production && environment.mode.prod) {
      return this.jwtService.storage.getData('identity') && this.jwtService.storage.getData('identity').username == 'nro-4c3s35f4ni' ? true : false
    } else {
      return true
    }
  }
  removeNonNumericCharacters(value: any): string {
    if (typeof value !== 'string') {
      return value
    }
    return value.replace(/\D/g, '');
  }
  returnGender(personObservable$: Observable<any>) {
    let gender = ''
    personObservable$.pipe(
      map(person => {
        gender = person.gender == 'MALE' ? 'MALE' : 'FEMALE'
      })).subscribe()
    return gender
  }
  checkDarkMode() {
    return this.localStorageService.getItem('theme') == 'dark'
  }
  getDateDisplay(dateInfo:any): string {
    let date = dateInfo
    if (date) {
      date = date.split('T')
      date[0] = date[0].split('-').reverse()
      date[0][1] = this.getMonth(+date[0][1])
      date[0][0] = date[0][0].split(' ')[0]
      date[0] = date[0].join(' ')
      return `${date[0]}`
    } else
      return 'تاریخ تولد را انتخاب کنید'
  }
  getMonth(mo: number): string {
    switch (mo) {
      case 1:
        return 'فروردین'
      case 2:
        return 'اردیبهشت'
      case 3:
        return 'خرداد'
      case 4:
        return 'تیر'
      case 5:
        return 'مرداد'
      case 6:
        return 'شهریور'
      case 7:
        return 'مهر'
      case 8:
        return 'آبان'
      case 9:
        return 'آذر'
      case 10:
        return 'دی'
      case 11:
        return 'بهمن'
      case 12:
        return 'اسفند'
      default:
        return ''
    }
  }
}